// extracted by mini-css-extract-plugin
export default {"DetailPost":"DetailPost_DetailPost__aCx-U","content":"DetailPost_content__6W1QO"};